import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogSlide = ({open, msg, handleClose}) => {

	return (<>   
		<Dialog
			open={open}
			TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			aria-describedby="alert-dialog-slide-description"
		>
        <DialogTitle>{"Apple Store"}</DialogTitle>
		<DialogContent>
			<DialogContentText id="alert-dialog-slide-description">
            {msg}
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={handleClose}>Close</Button>          
        </DialogActions>
      </Dialog>
    </>);
}

export default DialogSlide;